import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Injectable({
  providedIn: 'root'
})
export class ErrorMessageService {

  private readonly errorKeys: Record<string, string> = {
    'Entity not found AuthUser': 'resetPassword.messages.userNotFound'
  };

  constructor(private translate: TranslateService) {}

  getMessage(error: any, fallbackKey: string): string {
    const message = this.extractMessage(error);
    const translationKey = this.errorKeys[message] || fallbackKey;

    return this.translate.instant(translationKey);
  }

  private extractMessage(error: any): string {
    if (typeof error === 'string') {
      return error;
    }

    return error?.message
      || error?.error?.message
      || error?.error_description
      || error?.error
      || '';
  }
}
